import React from "react";

import Navbar from "../components/Navbar";
import PriceAndTiqBanner from "../components/PricingAndTiqBanner";
import Terms from "../components/Terms";
import Calltoaction from "../components/Calltoaction";
import Footer from "../components/Footer";

export default function TermsPage() {
  return (
    <>
      <Navbar />
      <PriceAndTiqBanner />
      <Terms />
      <Calltoaction />
      <Footer />
    </>
  );
}
